import { Typography } from '@mui/material'
import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { CircleTickMajor } from '@shopify/polaris-icons'
import { CollectDataStep } from 'src/interfaces/collectData'
import { CollectDataStepStatus } from 'src/constants/collect-data/enums'
import { getStepDisplayData } from 'src/utils/collectData'

interface Props {
  collectDataStep: CollectDataStep
  partIndex?: number
  className?: any
}

const StepItemComponent = ({ collectDataStep, partIndex, className }: Props) => {
  const stepData = getStepDisplayData(collectDataStep)

  const title = stepData.title
  const text = stepData.text
  const hideSubTitle = stepData?.hideSubTitle

  const completed = collectDataStep.status !== CollectDataStepStatus.Created

  if (!stepData) {
    return null
  }

  return (
    <Fragment>
      <div
        css={[
          tw`inline-flex flex-col items-start gap-2 p-4 bg-shades-0 overflow-hidden w-full`,
          className,
        ]}
      >
        <div css={tw`inline-flex items-center gap-4 flex-[0_0_auto]`}>
          {completed ? <CircleTickMajor width={20} css={tw`fill-success-500`} /> : stepData.icon}
          <div css={tw`flex flex-col gap-0.5`}>
            {!!partIndex && (
              <div
                css={[tw`rounded bg-shades-100 px-1 mb-0.5 w-fit`, completed && tw`bg-success-200`]}
              >
                <Typography
                  variant="overline"
                  fontWeight={700}
                  css={[tw`uppercase`, completed ? tw`text-success-500` : tw`text-shades-500`]}
                >{`Part ${partIndex}${completed ? ' • completed' : ''}`}</Typography>
              </div>
            )}
            {title && !hideSubTitle && <Typography variant="h4">{title}</Typography>}
            {!partIndex && <Typography css={tw`text-shades-400`}>{text}</Typography>}
          </div>
        </div>
        {!!partIndex && <Typography css={tw`text-shades-400`}>{text}</Typography>}
      </div>
    </Fragment>
  )
}

export const StepItem = memo(StepItemComponent)
